import { MissionData } from '../blocks/mission'
import template from './templates/RJF09.rbxl'
import thumbnail1 from './thumbnails/RJF09/WhiteBall.png'
import thumbnail2 from './thumbnails/RJF09/Trap.png'
import thumbnail3 from './thumbnails/RJF09/SpawnLocation.png'
import thumbnail4 from './thumbnails/RJF09/BlueBlock.png'
import thumbnail5 from './thumbnails/RJF09/YellowBlock.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①ボール',
      thumbnail: thumbnail1,
    },
    {
      name: '②トラップ',
      thumbnail: thumbnail2,
    },
    {
      name: '③スタートちてん',
      thumbnail: thumbnail3,
    },
    {
      name: '④ボールのかず',
      thumbnail: thumbnail4,
    },
    {
      name: '⑤トラップのかず',
      thumbnail: thumbnail5,
    },
  ],
}

export default mission
